import { useSelector } from "react-redux";
import {
  selectCarnetHoursTotal,
} from "../main.slice";
import { selectState as selectStateAuth } from "authentication/main.slice";
import { selectState as selectStateDashboard } from "Dashboard/dashboard.slice";
import { hasWriteAccessTo } from "utils/authUtil";
import { CARNET_PAYROLL_MODULE_NAME } from "Dashboard/scenes/Carnets/domain/CarnetModule";
import { useEffect, useState } from "react";

interface IProps {
  count: number;
}

const TableFooter = ({ count }: IProps) => {
  const { user } = useSelector(selectStateAuth);
  const carnetHoursTotals = useSelector(selectCarnetHoursTotal);
  const { provisions } = useSelector(selectStateDashboard);
  const [carnetHoursTotalsCleaned, setCarnetHoursTotalsCleaned] = useState<number[]>([]);

  useEffect(() => {
    if (provisions?.activeHourlyRateNames) {
      setCarnetHoursTotalsCleaned(provisions.activeHourlyRateNames.map(hourlyRate => carnetHoursTotals?.[hourlyRate.index] ?? 0));
    }
  }, [carnetHoursTotals, provisions?.activeHourlyRateNames]);

  return (
    <div
      className={`row ${hasWriteAccessTo(user, CARNET_PAYROLL_MODULE_NAME) ? "with-payroll" : ""}`}
      style={{ "--carnet-hour-columns": provisions?.activeHourlyRateNames.length } as React.CSSProperties}
    >
      <div className="col cell-count">
        <div className="bg-item-border-danger">{count}</div>
      </div>
      <div className="col" />
      <div className="col" />
      <div className="col" />
      {carnetHoursTotalsCleaned.map((total, index) => (
        <div className="col center strong" key={index}>
          <div className="bg-item-border-danger">{total}</div>
        </div>
      ))}
      <div className="col" />
      <div className="col" />
      <div className="col" />
      <div className="col" />
      <div className="col" />
      <div className="col" />
      <div className="col" />
    </div>
  );
};

export default TableFooter;
